const apiConfig = {
    baseUrl: 'https://api.themoviedb.org/3/',
    apiKey: '75b728f11d966d9b0f378ebccb4c77c9',
    originalImage: (imgPath) => `https://image.tmdb.org/t/p/original/${imgPath}`,
    w500Image: (imgPath) => `https://image.tmdb.org/t/p/w500/${imgPath}`
}

export default apiConfig;